<div class="w-full py-4">
  <p class="text-center mb-5">
    <b class="mr-1">Seleccione un archivo, o arrastre y suelte</b>
    <cite><small>(formatos aceptados: xlsx ó xls)</small></cite>
  </p>
  <div class="flex justify-center">
    <petrol-button variant="primary" (click)="input.click()">Cargar archivo</petrol-button>
  </div>
</div>

<input type="file" (change)="onFileChange($event, input)" #input hidden />

<div
  class="fixed top-0 left-0 bg-black/80 h-screen w-screen z-[1000] flex justify-center items-center transition-all duration-300"
  [ngClass]="{
    'opacity-0': !isDragging,
    'opacity-100': isDragging,
    'pointer-events-none': !isDragging,
    'pointer-events-auto': isDragging
  }"
  (dragleave)="mouseOut()"
>
  <div
    class="h-96 w-96 border-2 border-dashed rounded-xl flex justify-center items-center flex-col gap-5 pointer-events-none"
  >
    <p class="text-white font-bold">Suelte el archivo aquí</p>
    <i class="pi pi-arrow-up text-white animate-bounce text-2xl"></i>
  </div>
</div>

<c-dialog #dialog />
